// HACK: include polyfills for phantomjs browser to be able to run OWA karma tests
// we do not support IE in PROD and these may be removed when we get rid of
// phantomjs on OWA, f.e. run karma tests with Chrome in headless mode
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'core-js/features/array/includes';
import 'core-js/features/weak-map';
import 'core-js/features/weak-set';
import 'core-js/features/set';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import { DASHBOARD_PARAMETERS } from './constants/dashboard';

export { DASHBOARD_PARAMETERS };

export const renderDashboard = (params, targetElementId) =>
    ReactDOM.render(<App params={params} />, document.getElementById(targetElementId));

export const destroyDashboard = targetElementId =>
    ReactDOM.unmountComponentAtNode(document.getElementById(targetElementId));
